<template>
  <div class="orm-scrollcontainer orm-h100">
    <div
      class="orm-scrollcontainer__scroll"
      ref="scrollbox"
      :style="{ top: top }"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "Scrollcontainer",
  data() {
    return {
      top: 0,
      scrolloffsettop: 0,
      initHeight: 100,
    };
  },
  mounted() {
    this.heightcheck("init");
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.heightcheck);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.heightcheck);
  },

  methods: {
    heightcheck(type) {
      if (type == "init") {
        this.scrolloffsettop = this.$refs.scrollbox.offsetTop;
      }
      let resHeader = 0;

      if (
        document.getElementsByClassName("orm-reservationInfobar").length > 0
      ) {
        resHeader = document.getElementsByClassName("orm-reservationInfobar")[0]
          .clientHeight;
      }

      this.initHeight = this.scrolloffsettop - resHeader;
    },
    handleScroll() {
      const el = this.$el;
      const scroll = this.$refs.scrollbox;
      if (
        el.getBoundingClientRect().top < this.initHeight &&
        -el.getBoundingClientRect().top + this.initHeight <
          el.clientHeight - scroll.clientHeight - 24
      ) {
        this.top = -el.getBoundingClientRect().top + this.initHeight + "px";
      }
    },
  },
};
</script>
